var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waf-loading-spinner"},[_c('lottie-animation',{ref:"anim",attrs:{"animationData":require('@/assets/icons/animations/waf-data-loader.json'),"loop":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }